import { useState, useEffect } from 'react';
import { getLocationSuggestions, LocationSuggestion } from '@/services/locationService';
import { useDebounce } from '@/hooks/useDebounce';
import { useAutocompleteSettings } from '@/hooks/useAutocompleteSettings';

export const useLocationSuggestions = (inputValue: string) => {
  const debouncedInput = useDebounce(inputValue, 300);
  const [suggestions, setSuggestions] = useState<LocationSuggestion[]>([]);
  const [loading, setLoading] = useState(false);
  const enableAutocomplete = useAutocompleteSettings();

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (debouncedInput.trim().length < 2 || !enableAutocomplete) {
        setSuggestions([]);
        return;
      }

      setLoading(true);
      try {
        const results = await getLocationSuggestions(debouncedInput);
        setSuggestions(results);
      } catch (error) {
        console.error('Error fetching location suggestions:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSuggestions();
  }, [debouncedInput, enableAutocomplete]);

  return { suggestions, loading };
};